module.exports = __webpack_public_path__ + "static/media/3.4477976b.png";